import { CardInfo, ClaimModel, ClientUser } from '@/api'

export class ClaimForm implements ClaimModel {
  mainData: {
    snils: string
    middleName?: string
    lastName: string
    gender: number
    firstName: string
    birthPlace: string
    birthDate: string
  }
  contacts: {
    regAddress: string
    mobilePhone: string
    phone: string
    factAddress?: string
    temporaryRegAddress?: string
    emailAccept: boolean
    email: string
    smsAccept: boolean
  }
  cardInfo: {
    dateTo: string
    cardNumber: string
    qrData?: string
    bskNum?: string
  }

  constructor(user: ClientUser, cardToEdit?: CardInfo) {
    this.mainData = {
      snils: user.mainData?.snils ?? undefined,
      middleName: user.mainData?.middleName ?? undefined,
      lastName: user.mainData?.lastName ?? undefined,
      firstName: user.mainData?.firstName ?? undefined,
      birthPlace: user.mainData?.birthPlace ?? undefined,
      birthDate: user.mainData?.birthDate?.replace(/(\d+)\.(\d+)\.(\d+)/, '$3-$2-$1') ?? undefined,
      gender: user.mainData?.gender ?? undefined,
    }
    this.contacts = {
      regAddress: user.contacts?.regAddress ?? undefined,
      mobilePhone: user.contacts?.mobilePhone ?? undefined,
      phone: user.contacts?.phone ?? undefined,
      factAddress: user.contacts?.factAddress ?? undefined,
      temporaryRegAddress: user.contacts?.temporaryRegAddress ?? undefined,
      emailAccept: user.contacts?.emailAccept ?? undefined,
      email: user.contacts?.email ?? undefined,
      smsAccept: user.contacts.smsAccept ?? false,
    }
    this.cardInfo = {
      dateTo: cardToEdit?.dateTo.replace(/(\d+)\.(\d+)\.(\d+)/, '$3-$2-$1') ?? undefined,
      cardNumber: cardToEdit?.cardNumber ? `**** ***** **** ${cardToEdit?.cardNumber}` : undefined,
      qrData: cardToEdit?.qrData ?? undefined,
      bskNum: cardToEdit?.bskNum ?? undefined,
    }
  }

  get filled() {
    return (
      this.cardInfo.cardNumber &&
      this.cardInfo.dateTo &&
      this.mainData.birthDate &&
      this.mainData.birthPlace &&
      this.mainData.firstName &&
      !isNaN(this.mainData.gender) &&
      this.mainData.lastName &&
      this.mainData.snils &&
      this.contacts.email &&
      this.contacts.mobilePhone &&
      this.contacts.regAddress
    )
  }

  get isEdit() {
    return Boolean(this.cardInfo?.bskNum)
  }

  get toSave(): ClaimFormSerialize {
    return {
      mainData: {
        ...this.mainData,
        birthDate: new Date(this.mainData.birthDate).toLocaleDateString('RU-ru', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        }),
      },
      contacts: {
        ...this.contacts,
        factAddress: this.contacts.factAddress || undefined,
        temporaryRegAddress: this.contacts.temporaryRegAddress || undefined,
      },
      cardInfo: {
        cardNumber: this.cardInfo.cardNumber.replaceAll(' ', ''),
        dateTo: new Date(this.cardInfo.dateTo).toLocaleDateString('En-en', {
          month: '2-digit',
          year: '2-digit',
        }),
        qrData: this.cardInfo.qrData,
        bskNum: this.cardInfo.bskNum,
      },
    }
  }
}

export type ClaimFormSerialize = Omit<ClaimForm, 'filled' | 'toSave' | 'isEdit' | 'docType'>
